/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLayers = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m20.502 15.07.89 1.768L12 22l-9.391-5.162.889-1.768L12 19.79zm0-3.94.89 1.766L12 18.06l-9.391-5.163.889-1.767L12 15.85zM12 2l10 6.071-10 6.072L2 8.07zm0 2.26L6.096 8.071 12 11.883l5.904-3.812z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLayers as Layers };
